import { Inject } from '@angular/core';
import '@angular/compiler';
import { ComponentKieraAssistantWidgetComponent } from './component.kiera.assistant.widget/component.kiera.assistant.widget.component';
import { ComponentKieraRackEditorComponent } from './component.kiera.rack.editor/component.kiera.rack.editor.component';
import { ComponentKieraResourceUsersComponent } from './component.kiera.resource.users/component.kiera.resource.users.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageKieraComponent } from './page.kiera/page.kiera.component';
import { PageKieraActionsComponent } from './page.kiera.actions/page.kiera.actions.component';
import { PageKieraApiComponent } from './page.kiera.api/page.kiera.api.component';
import { PageKieraAssistantComponent } from './page.kiera.assistant/page.kiera.assistant.component';
import { PageKieraBmcCredentialsComponent } from './page.kiera.bmc.credentials/page.kiera.bmc.credentials.component';
import { PageKieraBmcDiscoveryComponent } from './page.kiera.bmc.discovery/page.kiera.bmc.discovery.component';
import { PageKieraChassisComponent } from './page.kiera.chassis/page.kiera.chassis.component';
import { PageKieraChassisItemComponent } from './page.kiera.chassis.item/page.kiera.chassis.item.component';
import { PageKieraClusterDeployComponent } from './page.kiera.cluster.deploy/page.kiera.cluster.deploy.component';
import { PageKieraClusterDeployItemComponent } from './page.kiera.cluster.deploy.item/page.kiera.cluster.deploy.item.component';
import { PageKieraClusterUsersComponent } from './page.kiera.cluster.users/page.kiera.cluster.users.component';
import { PageKieraClustersComponent } from './page.kiera.clusters/page.kiera.clusters.component';
import { PageKieraClustersItemComponent } from './page.kiera.clusters.item/page.kiera.clusters.item.component';
import { PageKieraDebugComponent } from './page.kiera.debug/page.kiera.debug.component';
import { PageKieraDisklessComponent } from './page.kiera.diskless/page.kiera.diskless.component';
import { PageKieraGroupsComponent } from './page.kiera.groups/page.kiera.groups.component';
import { PageKieraGroupsItemComponent } from './page.kiera.groups.item/page.kiera.groups.item.component';
import { PageKieraHelpComponent } from './page.kiera.help/page.kiera.help.component';
import { PageKieraImagesComponent } from './page.kiera.images/page.kiera.images.component';
import { PageKieraInspectComponent } from './page.kiera.inspect/page.kiera.inspect.component';
import { PageKieraJobsComponent } from './page.kiera.jobs/page.kiera.jobs.component';
import { PageKieraJujuComponent } from './page.kiera.juju/page.kiera.juju.component';
import { PageKieraKeysComponent } from './page.kiera.keys/page.kiera.keys.component';
import { PageKieraLogPolicyComponent } from './page.kiera.log.policy/page.kiera.log.policy.component';
import { PageKieraLogsComponent } from './page.kiera.logs/page.kiera.logs.component';
import { PageKieraLustreComponent } from './page.kiera.lustre/page.kiera.lustre.component';
import { PageKieraManagementSettingsComponent } from './page.kiera.management.settings/page.kiera.management.settings.component';
import { PageKieraNodesComponent } from './page.kiera.nodes/page.kiera.nodes.component';
import { PageKieraNodesApiRegisterComponent } from './page.kiera.nodes.api.register/page.kiera.nodes.api.register.component';
import { PageKieraNodesItemComponent } from './page.kiera.nodes.item/page.kiera.nodes.item.component';
import { PageKieraOperationsRackComponent } from './page.kiera.operations.rack/page.kiera.operations.rack.component';
import { PageKieraPeComponent } from './page.kiera.pe/page.kiera.pe.component';
import { PageKieraProvisioningRackComponent } from './page.kiera.provisioning.rack/page.kiera.provisioning.rack.component';
import { PageKieraRackComponent } from './page.kiera.rack/page.kiera.rack.component';
import { PageKieraRelayComponent } from './page.kiera.relay/page.kiera.relay.component';
import { PageKieraRelayItemComponent } from './page.kiera.relay.item/page.kiera.relay.item.component';
import { PageKieraScriptsComponent } from './page.kiera.scripts/page.kiera.scripts.component';
import { PageKieraSolComponent } from './page.kiera.sol/page.kiera.sol.component';
import { PageKieraSshAccessComponent } from './page.kiera.ssh.access/page.kiera.ssh.access.component';
import { PageKieraStatusComponent } from './page.kiera.status/page.kiera.status.component';
import { PageKieraSubnetsComponent } from './page.kiera.subnets/page.kiera.subnets.component';
import { PageKieraTerminalComponent } from './page.kiera.terminal/page.kiera.terminal.component';
import { PageKieraZabbixComponent } from './page.kiera.zabbix/page.kiera.zabbix.component';
import { PageKieraZonesComponent } from './page.kiera.zones/page.kiera.zones.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Injectable, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
    NuMonacoEditorComponent,
    NuMonacoEditorDiffComponent,
    provideNuMonacoEditorConfig,
} from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ standalone: false, name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateDefaultParser, TranslateLoader, TranslateModule, TranslateParser } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

@Injectable()
export class FlatKeyTranslateParser extends TranslateParser {
    private defaultParser = new TranslateDefaultParser();

    public interpolate(expr: string | Function, params?: any): any {
        return this.defaultParser.interpolate(expr, params);
    }

    public getValue(target: any, key: string): any {
        if (target && typeof key === 'string' && Object.prototype.hasOwnProperty.call(target, key)) {
            return target[key];
        }

        return this.defaultParser.getValue(target, key);
    }
}

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
ComponentKieraAssistantWidgetComponent,
ComponentKieraRackEditorComponent,
ComponentKieraResourceUsersComponent,
ComponentNavSidebarComponent,
LayoutEmptyComponent,
LayoutSidebarComponent,
PageAccessComponent,
PageKieraComponent,
PageKieraActionsComponent,
PageKieraApiComponent,
PageKieraAssistantComponent,
PageKieraBmcCredentialsComponent,
PageKieraBmcDiscoveryComponent,
PageKieraChassisComponent,
PageKieraChassisItemComponent,
PageKieraClusterDeployComponent,
PageKieraClusterDeployItemComponent,
PageKieraClusterUsersComponent,
PageKieraClustersComponent,
PageKieraClustersItemComponent,
PageKieraDebugComponent,
PageKieraDisklessComponent,
PageKieraGroupsComponent,
PageKieraGroupsItemComponent,
PageKieraHelpComponent,
PageKieraImagesComponent,
PageKieraInspectComponent,
PageKieraJobsComponent,
PageKieraJujuComponent,
PageKieraKeysComponent,
PageKieraLogPolicyComponent,
PageKieraLogsComponent,
PageKieraLustreComponent,
PageKieraManagementSettingsComponent,
PageKieraNodesComponent,
PageKieraNodesApiRegisterComponent,
PageKieraNodesItemComponent,
PageKieraOperationsRackComponent,
PageKieraPeComponent,
PageKieraProvisioningRackComponent,
PageKieraRackComponent,
PageKieraRelayComponent,
PageKieraRelayItemComponent,
PageKieraScriptsComponent,
PageKieraSolComponent,
PageKieraSshAccessComponent,
PageKieraStatusComponent,
PageKieraSubnetsComponent,
PageKieraTerminalComponent,
PageKieraZabbixComponent,
PageKieraZonesComponent,
PageMembersComponent,
PageMypageComponent,
PagePostsComponent,
PagePostsItemComponent,
PortalPostDetailComponent,
PortalPostListComponent,
PortalSeasonFormDropdownComponent,
PortalSeasonLoadingDefaultComponent,
PortalSeasonLoadingSeasonComponent,
PortalSeasonModalComponent,
PortalSeasonPaginationComponent,
PortalSeasonTreeComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorComponent,
        NuMonacoEditorDiffComponent,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            parser: {
                provide: TranslateParser,
                useClass: FlatKeyTranslateParser,
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        provideNuMonacoEditorConfig({ baseUrl: `lib` }),
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
